import {getBearer} from "../functions/getBearer";
import axios from "axios";
import {getApiLink} from "../functions/getApiLink";
import { setNotifications } from "../storage/toolkit";
import { GetAccessToken } from "./GetAccessToken";

export const SetNotifications = (dispatch: any) => {
    getBearer("get")
    axios.get(getApiLink(`/api/notifications/`)).then(({data}) => {
        // Check if data is HTML (ngrok interstitial page)
        if (typeof data === 'string' && data.includes('<!DOCTYPE html>')) {
            console.warn('SetNotifications: received HTML instead of JSON (ngrok interstitial page)')
            dispatch(setNotifications([]))
            return
        }
        const payload = Array.isArray(data) ? data : (data && Array.isArray(data.notifications) ? data.notifications : [])
        if (!Array.isArray(data)) console.warn('SetNotifications: unexpected response, using payload array', data)
        dispatch(setNotifications(payload))
    }).catch(er => {
        if (er?.response?.status === 401) {
            GetAccessToken(dispatch, SetNotifications)
        } else {
            console.error('SetNotifications error:', er)
            dispatch(setNotifications([]))
        }
    })
} 